import React, { useState } from 'react';

const FAQSection = ({ type = 'university' }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const universityFAQs = [
    {
      question: "¿Puedo pagar en cuotas?",
      answer: "Sí, ofrecemos pago flexible. Puedes pagar una cuota por cada clase (4 cuotas en total). Contáctanos por WhatsApp para coordinar el plan de pagos que mejor se ajuste a ti."
    },
    {
      question: "¿Qué incluye exactamente el curso?",
      answer: "El curso incluye 10 módulos prácticos (reclutamiento, manejo de modelos, estrategia de contenido, chatting, marketing, finanzas, automatización, estructura de agencia y escalamiento), acompañamiento 1 a 1, acceso a base de datos de modelos interesadas, y soporte durante y después del curso."
    },
    {
      question: "¿Cuánto tiempo dura el curso?",
      answer: "El curso consta de 4 sesiones intensivas de 2 horas cada una, para un total de 8 horas de formación. Puedes completarlo en 1-2 semanas dependiendo de tu disponibilidad."
    },
    {
      question: "¿Es online o presencial?",
      answer: "Es 100% online. Las sesiones son en vivo por videollamada, lo que te permite aprender desde cualquier lugar del mundo y tener interacción directa con el instructor."
    },
    {
      question: "¿Necesito experiencia previa?",
      answer: "No, el curso está diseñado tanto para principiantes como para personas que ya tienen experiencia. Empezamos desde cero y vamos avanzando paso a paso hasta estrategias avanzadas de escalamiento."
    },
    {
      question: "¿Garantizan resultados?",
      answer: "Si aplicas todo lo enseñado en el curso y sigues el acompañamiento 1 a 1, tendrás todas las herramientas necesarias para crear y escalar tu agencia. El éxito depende de tu compromiso y ejecución, pero te damos el conocimiento probado y el soporte necesario."
    },
    {
      question: "¿Qué pasa si no puedo asistir a una sesión en vivo?",
      answer: "Todas las sesiones quedan grabadas y tendrás acceso a ellas. Además, el acompañamiento 1 a 1 te permite resolver dudas específicas en cualquier momento."
    },
    {
      question: "¿Recibiré algún certificado?",
      answer: "Sí, al finalizar el curso recibirás un certificado digital de JGM University que valida tu formación en gestión de agencias OnlyFans."
    },
    {
      question: "¿Cómo funciona el acompañamiento 1 a 1?",
      answer: "Tendrás acceso directo conmigo vía WhatsApp para resolver dudas, revisar tu estrategia y recibir feedback personalizado. No estás solo en ningún paso del proceso."
    },
    {
      question: "¿Puedo empezar sin modelos?",
      answer: "¡Absolutamente! El módulo 1 te enseña exactamente cómo reclutar modelos desde cero, incluyendo scripts probados y estrategias de contacto. Además, tienes acceso a nuestra base de datos de modelos interesadas."
    }
  ];

  const modelFAQs = [
    {
      question: "¿Cómo funciona el trabajo con JGM Agency?",
      answer: "Tú te enfocas en crear contenido de calidad, nosotros manejamos todo lo demás: estrategia de contenido, chatting con suscriptores, marketing en redes sociales, y optimización de ganancias. Es un trabajo en equipo."
    },
    {
      question: "¿Qué porcentaje se queda la agencia?",
      answer: "Trabajamos con un modelo de comisión competitivo que se discute personalmente según tu caso. Contáctanos por WhatsApp para conocer los detalles específicos."
    },
    {
      question: "¿Necesito experiencia previa?",
      answer: "No, trabajamos con modelos nuevas y experimentadas. Si eres nueva, te guiamos en cada paso: desde la creación de tu perfil hasta tu primera venta."
    },
    {
      question: "¿Cuánto puedo ganar?",
      answer: "Los ingresos varían según tu dedicación, tipo de contenido y consistencia. Nuestras modelos activas generan desde $2,000 hasta $15,000+ USD mensuales. Te ayudamos a maximizar tu potencial."
    },
    {
      question: "¿Necesito mostrar mi cara?",
      answer: "No es obligatorio. Muchas modelos exitosas trabajan de forma anónima. Te ayudamos a crear una estrategia que se ajuste a tu nivel de comodidad."
    },
    {
      question: "¿Qué servicios exactamente me ofrecen?",
      answer: "Te ofrecemos: estrategia de contenido personalizada, gestión de chatting (mensajes con suscriptores), marketing en redes sociales, optimización de perfil, análisis de métricas, y soporte 24/7."
    },
    {
      question: "¿Debo pagar algo para empezar?",
      answer: "No, no cobramos ninguna tarifa inicial. Solo ganamos cuando tú ganas. Es una relación de beneficio mutuo donde estamos incentivados a maximizar tus resultados."
    },
    {
      question: "¿Cuánto tiempo debo dedicarle?",
      answer: "Recomendamos al menos 3-4 horas diarias para crear contenido. Nosotros manejamos el resto (chatting, marketing, estrategia), así que puedes enfocarte solo en la producción de contenido."
    },
    {
      question: "¿Qué tipo de contenido debo crear?",
      answer: "Trabajamos contigo para definir tu nicho y tipo de contenido según tu comodidad y el mercado. Puede ser desde contenido glamour hasta más explícito, tú decides tus límites."
    },
    {
      question: "¿Cómo me pagan mis ganancias?",
      answer: "Los pagos se realizan según el calendario acordado (quincenal o mensual) a través de transferencia bancaria o el método que prefieras. Todo es transparente y con reporte detallado."
    }
  ];

  const faqs = type === 'university' ? universityFAQs : modelFAQs;

  return (
    <section className="py-12 md:py-20 px-4 bg-black/20" data-section="faq">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-3 md:mb-4">
            Preguntas Frecuentes
          </h2>
          <p className="text-sm md:text-base text-gray-400">
            Resuelve tus dudas antes de dar el siguiente paso
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-black/60 backdrop-blur-sm border border-[#c8784e]/30 rounded-lg overflow-hidden hover:border-[#c8784e]/60 transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full text-left p-4 md:p-6 flex items-center justify-between gap-4 hover:bg-black/40 transition-colors"
              >
                <span className="text-white font-semibold text-sm md:text-base pr-4">
                  {faq.question}
                </span>
                <svg 
                  className={`w-5 h-5 text-[#c8784e] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <div className="p-4 md:p-6 pt-0 text-gray-300 text-sm md:text-base leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA después de FAQ */}
        <div className="mt-8 md:mt-12 text-center">
          <p className="text-gray-400 mb-4">¿Tienes más preguntas?</p>
          <a 
            href="https://wa.link/0wlub8"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#c8784e] text-black px-6 md:px-8 py-3 md:py-4 rounded-lg font-bold text-sm md:text-base hover:bg-[#d89a6f] transition-all duration-300 hover:scale-105"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
            Contáctanos por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
